<template>
    <b-list-group-item>
        <div class="d-flex justify-content-between mb-1" @click="isInModal && selectAllOrders(delivery.orders)"><span>№ {{delivery.id}}</span> <span>{{delivery.status.name}}</span></div>

        <b-list-group-item
          v-for="ord in delivery.orders"
          :key="ord.id"
          class="orderInDelivery"
          :class="{ activeIt: isInModal && selectedOrders && selectedOrders.includes(ord.id) }"
          @click="isInModal && selectOrder(ord)"
        >
            <order-block type="delivery-list-all" :order="ord" :order-stages="orderStages" />
        </b-list-group-item>

        <div
          class="d-flex justify-content-between"
          v-if="CAA === false && (delivery.status.keyword === STATUS_DELIVERY.NEW || delivery.status.keyword === STATUS_DELIVERY.CHOSEN_COURIER) && isSuperLogistician"
        >
            <b-button  @click.stop="$emit('disband-delivery', delivery)" variant="danger" class="px-2 py-0 pb-1 flex-grow-1"><icon name="trash-alt"></icon></b-button>
            <b-button  :disabled="numberSelectedOrders === 0" @click.stop="$emit('add-order-to-delivery', delivery)" class="px-2 py-0 pb-1 flex-grow-1" variant="success"><icon name="plus"></icon></b-button>
        </div>

        <b-form-group v-if="showCourier && delivery.status.keyword !== STATUS_DELIVERY.END && isSuperLogistician" label-size="sm" class="mb-0 mt-0" label="Курьер:">
            <b-form-select @change="changeCourier" v-model="selectedCourier" :options="couriersOptions"></b-form-select>
        </b-form-group>
    </b-list-group-item>
</template>

<script>
import {STATUS_DELIVERY} from '../constants/keywords'
import OrderBlock from './OrderBlock'
import orderFunc from '@/functionsLib/orderFunc'
import {
  USER_ROLE_SUPER_LOGISTICIAN
} from '@/constants/roles'

export default {
  name: 'DeliveryItem',
  props: {
    delivery: {
      type: Object,
      required: true
    },
    numberSelectedOrders: {
      type: Number,
      required: true
    },
    type: String,
    isInModal: {
      type: Boolean,
      default () {
        return false
      }
    },
    selectedDelivery: Number,
    selectedOrders: {
      type: Array
    },
    couriers: {
      type: Array,
      default () { return [] }
    },
    CAA: {
      type: Boolean
    },
    role: {
      type: String
    },
    orderStages: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      STATUS_DELIVERY,
      selectedCourier: null,
      lastDeliveryId: null,
      selectedOrdersTemp: []
    }
  },
  computed: {
    isSuperLogistician () {
      return this.role === USER_ROLE_SUPER_LOGISTICIAN
    },
    showCourier () {
      return this.type === 'delivery-list-all'
    },
    couriersOptions () {
      return this.couriers.map(el => {
        return {
          value: el,
          text: this.shortNameWorker(el)
        }
      })
    }
  },
  methods: {
    shortNameWorker: orderFunc.shortNameWorker,
    changeCourier (courier) {
      if (this.isSuperLogistician) {
        let emitQuery = this.selectedOrders.length === 0 ? 'change-courier' : 'assign-courier'
        this.$emit(emitQuery, {delivery: this.delivery, courier: courier})
      }
    },
    selectAllOrders (orders) {
      if (this.isSuperLogistician) {
        orders.forEach((order) => {
          this.selectOrder(order)
        })
      }
    },
    selectOrder (order) {
      if (this.isSuperLogistician) {
        this.$emit('select-order', {order: order})
      }
    }
  },
  components: {
    OrderBlock
  }
}
</script>

<style scoped lang="scss">
  .orderInDelivery {
    &.activeIt {
      background: #eeffc4;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DeliveryItem.vue